import { useTracker } from '@/core/tracking';
import { useLocalization } from '@/services/localizationService';
import { TaskType } from '@/services/uploaderService';
import { mediaState } from '@/stores/mediaStore';
import { previousMediaTypeState } from '@/stores/previousMediaTypeStore';
import { useCallback } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

export const useUploadNewButton = () => {
  const { track } = useTracker();
  const { t, data } = useLocalization();
  const media = useRecoilValue(mediaState);
  const setPreviousMediaType = useSetRecoilState(previousMediaTypeState);

  const onClick = useCallback(() => {
    track('upload_new', 'tapped');
    setPreviousMediaType(media.mediaType as TaskType);
  }, [media.mediaType, setPreviousMediaType, track]);

  return { onClick, text: t(data.result.newUpload) };
};
